module.exports = __webpack_public_path__ + "img/qimen_wealthbusiness.ec27f224.png";